import Glide from '@glidejs/glide';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {

    const initEventAnimation = () => {
        let mm = gsap.matchMedia();

        mm.add("(min-width: 1200px)", () => {
            const cards = gsap.utils.toArray(".event__card");
            const bullets = gsap.utils.toArray(".event__bullet");
            const cardsContainer = document.querySelector(".event__cards");

            if (!cardsContainer || cards.length === 0) return;

            // Función para obtener totalY siempre fresco
            const getTotalY = () => cardsContainer.scrollHeight - cardsContainer.offsetHeight;

            // SOLUCIÓN 1: usar una referencia compartida al multiplicador
            const MULTIPLIER = 1.6;

            const pinTrigger = ScrollTrigger.create({
                trigger: ".event__section",
                start: "top top",
                end: () => `+=${getTotalY() * MULTIPLIER}`,
                pin: ".event__wrapper",
                pinSpacing: true,
                anticipatePin: 1,
                invalidateOnRefresh: true, // SOLUCIÓN 2: recalcula al hacer resize/refresh
            });

            gsap.to(cardsContainer, {
                y: () => -getTotalY(),
                ease: "none",
                scrollTrigger: {
                    trigger: ".event__section",
                    start: "top top",
                    end: () => `+=${getTotalY() * MULTIPLIER}`,
                    scrub: true,
                    invalidateOnRefresh: true, // SOLUCIÓN 2: recalcula al hacer resize/refresh
                    snap: {
                        snapTo: 1 / (cards.length - 1),
                        duration: { min: 0.2, max: 0.5 },
                        delay: 0,
                        ease: "power1.inOut"
                    },
                    onUpdate: (self) => {
                        const progress = self.progress;
                        const index = Math.min(Math.round(progress * (cards.length - 1)), cards.length - 1);

                        bullets.forEach((bullet, i) => {
                            bullet.classList.toggle("active", i === index);
                        });

                        cards.forEach((card, i) => {
                            const cardProgress = progress * (cards.length - 1);
                            const distance = Math.abs(cardProgress - i);
                            const opacity = 1 - Math.min(distance * 0.2, 0.2);
                            const blur = Math.min(distance * 3, 3);

                            gsap.to(card, {
                                opacity,
                                filter: `blur(${blur}px)`,
                                duration: 0.1,
                                overwrite: "auto"
                            });
                        });
                    }
                }
            });
        });
    };

    // SOLUCIÓN 3: esperar a que todas las imágenes del contenedor carguen antes de inicializar
    const images = document.querySelectorAll(".event__card-img");
    let loaded = 0;
    const total = images.length;

    if (total === 0) {
        initEventAnimation();
        return;
    }

    const onLoad = () => {
        loaded++;
        if (loaded >= total) {
            initEventAnimation();
            ScrollTrigger.refresh(); // refresca por si acaso el layout cambió
        }
    };

    images.forEach(img => {
        if (img.complete) {
            onLoad();
        } else {
            img.addEventListener('load', onLoad);
            img.addEventListener('error', onLoad); // si falla también continúa
        }
    });

});

//slider de talleres
if (document.querySelector('.programme__slider')) {
    new Glide('.programme__slider', {
        type: 'carousel',
        startAt: 0,
        perView: 4,
        gap: 30,
        breakpoints: {
            1200: {
                perView: 3,
            },
            992: {
                perView: 2,
            },
            768: {
                perView: 1,
            },
        },
    }).mount();
}

//slider de ofertas de empleo
if (document.querySelector('.jobs__slider')) {
    new Glide('.jobs__slider', {
        type: 'carousel',
        startAt: 0,
        perView: 3,
        autoplay: 7000,
        gap: 30, // Aumentamos un poco el espacio entre tarjetas
        breakpoints: {
            1200: {
                perView: 2, // 2 tarjetas cuando el slider ocupa el 100% del ancho
                gap: 20
            },
            992: {
                perView: 1, // Cambiamos a 1 tarjeta en tablets para evitar que se corten
                gap: 0
            },
            768: {
                perView: 1,
                gap: 0
            }
        }
    }).mount();
}

//slider de ponentes
if (document.querySelector('.speaker__slider')) {
    new Glide('.speaker__slider', {
        type: 'carousel',
        startAt: 0,
        perView: 3,
        autoplay: 7000,
        gap: 30, // Aumentamos un poco el espacio entre tarjetas
        breakpoints: {
            1200: {
                perView: 2, // 2 tarjetas cuando el slider ocupa el 100% del ancho
                gap: 20
            },
            992: {
                perView: 1, // Cambiamos a 1 tarjeta en tablets para evitar que se corten
                gap: 0
            },
            768: {
                perView: 1,
                gap: 0
            }
        }
    }).mount();
}

//numero de sliders visibles en el slider de los talleres
function getVisibleSlides() {
    const containerWidth = document.querySelector('.glide__track').offsetWidth;
    if (document.querySelector('.section3a__item') != null){
        const slideWidth = document.querySelector('.section3a__item').offsetWidth;
        // Número de slides visibles (se redondea hacia abajo para obtener el entero)
        const visibleSlides = Math.floor(containerWidth / slideWidth);
        return visibleSlides*2;
    }
}
